import React from 'react';
import './style.css';
import clsx from 'clsx';
import { ReactComponent as Plus } from "../../../src/assets/images/plus.svg";

function ButtonMain(props) {
  const {
    title = 'title',
    onClick = () => { },
    className,
    disabled = false,
    showIcon = false, // New prop to control icon visibility
  } = props;

  return (
    <div className="btn-div">
      <button className={clsx(className, 'buttonStyle')} type="button" onClick={onClick} disabled={disabled}>
        {showIcon && <div className="bplus-icon"><Plus /></div>}
        {title}
      </button>
    </div>
  );
}

export default ButtonMain;